import { Partial } from '@40seas/entities/common';
import { CreatePayoutDto } from './create.payout.dto';

export class UpdatePayoutDto extends Partial(CreatePayoutDto) {}
